import { render, staticRenderFns } from "./User.vue?vue&type=template&id=09881568&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=09881568&prod&scoped=true&lang=css"
import style1 from "./User.vue?vue&type=style&index=1&id=09881568&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09881568",
  null
  
)

export default component.exports